"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = require("../component");

var _config = require("../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var _default = function _default(Com, name) {
  return (
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(_class, _Component);

      function _class(props) {
        var _this;

        _this = _Component.call(this, props) || this;
        _this.handleUpdate = _this.forceUpdate.bind(_assertThisInitialized(_assertThisInitialized(_this)));

        _config.noti.subscribe(name, _this.handleUpdate);

        return _this;
      }

      var _proto = _class.prototype;

      _proto.componentWillUnmount = function componentWillUnmount() {
        _config.noti.unsubscribe(name, this.handleUpdate);
      };

      _proto.render = function render() {
        return _react.default.createElement(Com, this.props);
      };

      return _class;
    }(_component.Component)
  );
};

exports.default = _default;